import { EventEmitter } from "events";

const EE = new EventEmitter();

export const Events = {
  DOWNLOAD: "download",
  UPGRADETOPRO: "upgradeToPro",
  LOGIN: "login",
  TRACK_BUTTON_CLICK: "trackButtonClick",
  AI_BG_GENERATOR: "aiBgGenaration",
  SEARCH: "search",
  NAVBAR_3D_ClICK: "navbar3DClicked",
  DOWNLOAD_3D: "download3D",
  SELECT_ASPECT_RATIO: "selectAspectRatio",
  DOWNLOAD_VIDEO_3D_CLICK: "downloadVideo3dClicked",
  DOWNLOAD_WALKING_ANIMATION: "downloadWalkingAnimation",
  SELECT_SIDEBAR_OPTION: "selectSidebarOption",
  IMAGE_UPLOADED: "imageUploadedCM",
  DESIGN_UPLOADED: "designUploadedCM",
  CUSTOM_MOCKUP_DOWNLOAD: "downloadCM",
  DESIGN_UPLOAD_VIDEO_MOCKUP: "designUploadVM",
  CLICK_GENERATE_VIDEO_MOCKUP: "clickGenerateVM",
};

class Proxy {
  emit(name, ...value) {
    return EE.emit(name, ...value);
  }

  on(name, cb) {
    return EE.on(name, cb);
  }

  cleanup() {
    return EE.removeAllListeners();
  }

  download(data) {
    this.emit(Events.DOWNLOAD, data);
  }

  upgradeToPro(data) {
    this.emit(Events.UPGRADETOPRO, data);
  }

  login(data) {
    this.emit(Events.LOGIN, data);
  }

  trackButtonClick(data) {
    this.emit(Events.TRACK_BUTTON_CLICK, data);
  }

  aiBgGeneration(data) {
    this.emit(Events.AI_BG_GENERATOR, data);
  }

  search(data) {
    this.emit(Events.SEARCH, data);
  }

  navbar3DClicked(data) {
    this.emit(Events.NAVBAR_3D_ClICK, data);
  }

  download3D(data) {
    this.emit(Events.DOWNLOAD_3D, data);
  }

  selectAspectRatio(data) {
    this.emit(Events.SELECT_ASPECT_RATIO, data);
  }

  downloadVideo3dClicked(data) {
    this.emit(Events.DOWNLOAD_VIDEO_3D_CLICK, data);
  }

  downloadWalkingAnimation(data) {
    this.emit(Events.DOWNLOAD_WALKING_ANIMATION, data);
  }

  selectSidebarOption(data) {
    this.emit(Events.SELECT_SIDEBAR_OPTION, data);
  }

  imageUploadedCM(data) {
    this.emit(Events.IMAGE_UPLOADED, data);
  }

  designUploadedCM(data) {
    this.emit(Events.DESIGN_UPLOADED, data);
  }

  downloadCM(data) {
    this.emit(Events.CUSTOM_MOCKUP_DOWNLOAD, data);
  }

  designUploadVM(data) {
    this.emit(Events.DESIGN_UPLOAD_VIDEO_MOCKUP, data);
  }

  clickGenerateVM(data) {
    this.emit(Events.CLICK_GENERATE_VIDEO_MOCKUP, data);
  }
}

export const Emitter = new Proxy();
